import {
  IBilletesFalsosConfig,
  IBilletesFalsosConfigData,
  ICountryConfig,
  ICountryConfigData,
  IDemandaConfig,
  IDemandaConfigData,
  IOfertaConfig,
  IOfertaConfigData,
  IPais,
  ITransferenciasConfig,
  ITransferenciasConfigData,
} from "@/entities";
import { i18n } from "@/i18n";

export class Pais implements IPais {
  codPais: string;
  codPaisCorto: string;
  codTimezone: string;
  descripcion: string;
  hasTasa: boolean;
  admiteAnonimo: boolean;
  hasTransportadora: boolean;
  hasAprobacionAutomaticaOferta: boolean;
  hasTasaEnteros: boolean;
  id: number;
  soConfig: ICountryConfig;
  dateFormat: string;
  idioma: string;
  intercambioDelegaciones: boolean;
  importCheck: boolean;
  bcr: boolean;
  hasInfoBancaria: boolean;
  diasVisualizarVideos: number;
  descargarVideos: boolean;
  hasInformeComprasVentas: boolean;
  iva: number;
  reportsLegacy: boolean;
  editOfertasDemandas: boolean;

  constructor(data?: IPais) {
    if (data) {
      this.codPais = data.codPais;
      this.codPaisCorto = data.codPaisCorto;
      this.codTimezone = data.codTimezone;
      this.descripcion = i18n.t(`label.country.${data.codPais}`)
        ? i18n.t(`label.country.${data.codPais}`)
        : data.descripcion;
      this.hasTasa = data.hasTasa || false;
      this.admiteAnonimo = data.admiteAnonimo || true;
      this.hasTransportadora = data.hasTransportadora || false;
      this.hasAprobacionAutomaticaOferta = data.hasAprobacionAutomaticaOferta || false;
      this.hasTasaEnteros = data.hasTasaEnteros || false;
      this.id = data.id;
      this.soConfig = new CountryConfig(data.soConfig || {});
      this.dateFormat = data.dateFormat;
      this.idioma = data.idioma;
      this.intercambioDelegaciones = data.intercambioDelegaciones;
      this.importCheck = data.importCheck;
      this.bcr = data.bcr;
      this.hasInfoBancaria = data.hasInfoBancaria;
      this.diasVisualizarVideos = data.diasVisualizarVideos;
      this.descargarVideos = data.descargarVideos;
      this.hasInformeComprasVentas = data.hasInformeComprasVentas || false;
      this.iva = data.iva;
      this.reportsLegacy = data.reportsLegacy || false;
      this.editOfertasDemandas = data.editOfertasDemandas || false;
    } else {
      this.codPais = "";
      this.codPaisCorto = "";
      this.codTimezone = "";
      this.descripcion = "";
      this.id = 0;
      this.hasTasa = false;
      this.admiteAnonimo = true;
      this.hasTransportadora = false;
      this.hasAprobacionAutomaticaOferta = false;
      this.hasTasaEnteros = false;
      this.soConfig = {
        BilletesFalsos: {
          Enabled: true,
        },
        Transferencias: {
          Oferta: {
            ShowInfoBancaria: false,
          },
          Demanda: {
            ShowInfoBancaria: false,
          },
        },
      };
      this.dateFormat = "";
      this.idioma = "";
      this.intercambioDelegaciones = false;
      this.importCheck = false;
      this.bcr = false;
      this.hasInfoBancaria = false;
      this.diasVisualizarVideos = 7;
      this.descargarVideos = false;
      this.hasInformeComprasVentas = false;
      this.iva = 0;
      this.reportsLegacy = false;
      this.editOfertasDemandas = false;
    }
  }
}

export class BilletesFalsosConfig implements IBilletesFalsosConfig {
  readonly Enabled?: boolean;
  constructor(data: IBilletesFalsosConfigData) {
    this.Enabled = data.Enabled || true;
  }
}

class OfertaConfig implements IOfertaConfig {
  readonly ShowInfoBancaria: boolean;
  constructor(data: IOfertaConfigData) {
    this.ShowInfoBancaria = data.ShowInfoBancaria || false;
  }
}
class DemandaConfig implements IDemandaConfig {
  readonly ShowInfoBancaria: boolean;
  constructor(data: IDemandaConfigData) {
    this.ShowInfoBancaria = data.ShowInfoBancaria || false;
  }
}

class TransferenciasConfig implements ITransferenciasConfig {
  readonly Oferta: OfertaConfig;
  readonly Demanda: DemandaConfig;
  constructor(data: ITransferenciasConfigData) {
    this.Oferta = new OfertaConfig(data.Oferta || {});
    this.Demanda = new DemandaConfig(data.Demanda || {});
  }
}

export class CountryConfig implements ICountryConfig {
  readonly BilletesFalsos: BilletesFalsosConfig;
  readonly Transferencias: TransferenciasConfig;

  constructor(data: ICountryConfigData) {
    this.BilletesFalsos = new BilletesFalsosConfig(data.BilletesFalsos || {});
    this.Transferencias = new TransferenciasConfig(data.Transferencias || {});
  }
}
